import "../ui/zod-jitless.ts";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "../ui/tokens.css";
import "../ui/theme.css";
import "./site.css";
import { App } from "./App.tsx";

// The customer site is always dark (the shared tokens would otherwise follow the OS light theme).
document.documentElement.dataset.theme = "dark";
// Mobile browser chrome matches the black header.
document
  .querySelector('meta[name="theme-color"]')
  ?.setAttribute("content", getComputedStyle(document.documentElement).getPropertyValue("--bw-black").trim() || "black");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
